"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n"], ["\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: "CalendarIcon__Container",
  componentId: "jhkqgo-0"
})(_templateObject);

var CalendarIcon = function CalendarIcon(props) {
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(
      "svg",
      { width: "16px", height: "17px", viewBox: "0 0 16 17", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
      _react2.default.createElement(
        "g",
        { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
        _react2.default.createElement(
          "g",
          { transform: "translate(-539.000000, -290.000000)", stroke: props.theme.colors.neutral },
          _react2.default.createElement(
            "g",
            { transform: "translate(540.000000, 291.000000)" },
            _react2.default.createElement("rect", { x: "0", y: "1.07142857", width: "14", height: "13.9285714", rx: "2" }),
            _react2.default.createElement("path", { d: "M9.69230769,0 L9.69230769,3.21428571" }),
            _react2.default.createElement("path", { d: "M4.30769231,0 L4.30769231,3.21428571" }),
            _react2.default.createElement("path", { d: "M0,6.42857143 L14,6.42857143", id: "Shape" })
          )
        )
      )
    )
  );
};

exports.default = (0, _styledComponents.withTheme)(CalendarIcon);


//////////////////
// WEBPACK FOOTER
// ./~/buoy-date-picker/dist/components/CalendarIcon.js
// module id = 400
// module chunks = 168707334958949